export var FEATURE_FLAGS_V5 = /*#__PURE__*/function (FEATURE_FLAGS_V5) {
  FEATURE_FLAGS_V5["MODULE_HANA_AI"] = "MODULE_HANA_AI";
  FEATURE_FLAGS_V5["KNOWLEDGE_HUB"] = "KNOWLEDGE_HUB";
  FEATURE_FLAGS_V5["LIVE_SESSIONS_STAGE_1"] = "LIVE_SESSIONS_STAGE_1";
  FEATURE_FLAGS_V5["LEARNING_ACCESS_LEVEL_LMS"] = "LEARNING_ACCESS_LEVEL_LMS";
  return FEATURE_FLAGS_V5;
}({});
export var FEATURE_FLAGS_V5_KEYS = /*#__PURE__*/Object.values(FEATURE_FLAGS_V5);